<template>
    <div class="author-manager" v-if="isAuthor || isManager">
        <div class="cont-row">
            <div class="flex-cont">

                <div class="no-popular" v-if="productList.length == 0">
                    立即付费推广，增加曝光率
                </div>

                <div class="has-popular" v-if="productList.length > 0">
                    <div class="lab">广告类型：</div>
                    <div v-for="(item) in productList" :key="item.id" class="ykd-item">
                        <span class="type">{{ item.adTitleSnapshot }}</span>
                        {{ item.expiredAt | torontoTimeFormat('YYYY-MM-DD') }}到期
                    </div>
                </div>

            </div>
            <a class="manger-button now-buy-pay" target="_blank"
                :href="`/popularize/promotion/car/${$route.params.id}` | hostBuild('home')" v-if="top == 0 || top == 1">
                <i class="yk-merchant_ad"></i>
                <span>立即推广</span>
            </a>
            <a class="manger-button now-buy-pay"
                :href="`/popularize/promotion/car/${$route.params.id}` | hostBuild('home')" v-else>
                <i class="yk-merchant_ad"></i>
                <span>立即续费</span>
            </a>
            <router-link class="manger-button"
                :to="`/publish/${this.post.property.topics[0].englishName}?id=${$route.params.id}`">
                <i class="yk-detail-edit"></i>
                <span>编辑</span>
            </router-link>

            <button class="manger-button" @click="onDelete">
                <i class="yk-detail-del"></i>
                <span>删除</span>
            </button>
        </div>
    </div>
</template>
<script>
import { dayjs } from '@/utils/dayjs'
import { hostBuild } from '@/utils/utils';
export default {
    name: 'AuthorManager',
    props: { post: Object },
    computed: {
        // 作者
        isAuthor() {
            //return true
            return this.post.user.id == this.$store.getters.user.id;
        },
        // 管理员
        isManager() {
            return this.post.loginUserInfo && this.post.loginUserInfo.identity == 3;
        },
        topicsTopAdType() {
            //2 免费显示  3付费显示
            return this.post.property.topics[0].topAdType;
        },
        productList() {

            let list = this.post.property.productList || [];
            let resultList = [];
            for (var i = 0; i < list.length; i++) {
                if (resultList.length == 0) {

                    resultList.push({ ...list[i] });
                } else {
                    if (resultList[resultList.length - 1].categoryId == list[i].categoryId) {
                        resultList[resultList.length - 1].daysSnapshot += list[i].daysSnapshot;
                    } else {
                        resultList.push({ ...list[i] });
                    }
                }
            }
            return resultList;
        },
        top() {
            return this.post.property.top || 0;
        },
        editorRecommend() {
            return this.post.property.editorRecommended || 0;
        }
    },
    data() {
        return {

        }
    },
    methods: {
        adEndTime(index) {
            let payStartTimeStr = this.productList[0].payedAt;
            let payStartTime = dayjs(payStartTimeStr);
            console.log('*****************')
            console.log(payStartTime);
            for (var i = 0; i < this.productList.length; i++) {
                payStartTime = payStartTime.add(this.productList[i].daysSnapshot, 'day');
                console.log(payStartTime);
                if (index == i) {
                    break;
                }
            }

            return payStartTime.toDate().toISOString();

        },
        /**
         * 删除
         */
        async onDelete() {
            const isConfirm = await this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).catch(() => false);

            if (!isConfirm) return;

            if (this.deleteLoading) return;

            this.deleteLoading = true;
            await this.$axios
                .post('/car/v1/drop/post', {
                    postId: [this.$route.params.id],
                })
                .finally(() => {
                    this.deleteLoading = false;
                });

            this.$success('删除成功');

            this.$router.replace(`/list/${this._toipic}`);
        },
    }
}
</script>
<style lang="scss" scoped>
.author-manager {
    padding: 10px 20px;
    margin-top: 20px;
    background-color: rgba(252, 220, 63, .15);
    color: #E43A3A;
}

.cont-row {
    display: flex;
}

.flex-cont {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.no-popular {
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
}

.has-popular {
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;

    .lab {
        color: var(--text-color-9);
        margin-right: 5px;
    }

    .ykd-item {
        color: var(--text-color-3);
        margin-right: 20px;

        .type {
            color: var(--primary-color);
            font-weight: bold;
        }
    }
}

.manger-button {
    display: flex;
    align-items: center;

    &.now-buy-pay {
        background: var(--primary-color);
        height: 36px;
        border-radius: 4px;
        color: #fff;
        padding: 0 20px;

        &:hover {
            background: rgba(228, 58, 58, .8);
        }
    }

    &:not(:last-child) {
        margin-right: 40px;
    }

    font-size: 14px;

    i {
        margin-right: 5px;
        font-size: 12px;
    }
}
</style>